import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Dans quelles zones intervenez-vous ?",
    a: "Nous intervenons sur l'ensemble de l'Île-de-France : Paris, Hauts-de-Seine, Seine-Saint-Denis, Val-de-Marne, Essonne, Yvelines, Seine-et-Marne et Val-d'Oise. Pour les prestations régulières, nous adaptons la logistique selon la localisation du site.",
  },
  {
    q: "Proposez-vous des prestations ponctuelles ou uniquement des contrats réguliers ?",
    a: "Les deux. Nous gérons aussi bien les contrats d'entretien réguliers (quotidien, hebdomadaire, mensuel) que les interventions ponctuelles : grand nettoyage, fin de chantier, remise en état, vitrerie, cristallisation de sols, etc.",
  },
  {
    q: "Combien de temps pour obtenir un devis ?",
    a: "Nous vous rappelons sous 24h ouvrées pour planifier une visite gratuite. Le devis détaillé vous est ensuite transmis sous 48h après la visite — sans engagement et parfaitement adapté à vos besoins.",
  },
  {
    q: "Vos produits sont-ils respectueux de l'environnement ?",
    a: "Oui. Nous utilisons majoritairement des gammes éco-certifiées (Ecolabel, EU Flower) et des microfibres lavables pour limiter l'impact environnemental. Des produits spécifiques sont utilisés pour les environnements sensibles (médical, alimentaire).",
  },
  {
    q: "Votre personnel est-il assuré et déclaré ?",
    a: "Intégralement. Nos agents sont salariés en CDI ou CDD, déclarés, formés aux protocoles d'hygiène et couverts par notre assurance responsabilité civile professionnelle. Une attestation peut vous être fournie sur demande.",
  },
  {
    q: "Intervenez-vous en dehors des horaires d'ouverture ?",
    a: "Absolument. Nous adaptons nos horaires d'intervention (tôt le matin, en soirée ou la nuit) pour ne pas perturber votre activité. Nos équipes disposent des équipements nécessaires pour travailler en autonomie.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#F8FAFC]" data-testid="faq-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#2E9E6E] font-medium mb-4">
              — Questions fréquentes
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl text-[#0F2B5B] leading-[1.02] tracking-tight">
              Ce que vous vous demandez sûrement.
            </h2>
          </div>
          <div className="md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-slate-200"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold text-[#0F2B5B] hover:text-[#2E9E6E] hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-slate-600 leading-relaxed text-base">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
